import { IconButton, Stack, Typography } from "@mui/material";
import { numberFormat } from "../../helpers/numberFormat";

import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PreviewIcon from "@mui/icons-material/Preview";
import { toSpanishDate } from "../../helpers/dateFormat";

export const columnsFunds = (t, onDeleteClick, onEditClick, onViewClick) => {
  return [
    {
      field: "name",
      headerName: t("funds.name"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "registrationDate",
      headerName: t("funds.registrationDate"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {toSpanishDate(params.row.registrationDate)}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: t("funds.amount"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {params.row.amount ? numberFormat(params.row.amount) : 0}
          </Typography>
        );
      },
    },
    {
      field: "percentagePaid",
      headerName: t("funds.percentagePaid"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {params.row.percentagePaid}%
          </Typography>
        );
      },
    },
    {
      field: "amountPaid",
      headerName: t("funds.amountPaid"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const percentagePaid = params.row.percentagePaid;
        const amount = params.row.amount;
        const result = amount * (percentagePaid / 100);
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(result)}
          </Typography>
        );
      },
    },
    {
      field: "amountParticipants",
      headerName: t("funds.amountParticipants"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {params.row.amountParticipants}
          </Typography>
        );
      },
    },
    {
      field: "toBePaid",
      headerName: t("funds.toBePaid"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const percentagePaid = params.row.percentagePaid;
        const amount = params.row.amount;
        const result = amount * (percentagePaid / 100);
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(amount - result)}
          </Typography>
        );
      },
    },

    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 130,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onViewClick(params)}>
              <PreviewIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
};

export const columnsViewFund = (t, onDeleteClick, onEditClick, onViewClick) => {
  return [
    {
      field: "idCrm",
      headerName: t("partnerlist.idCrm"),
      minWidth: 80,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: t("funds.nameUser"),
      minWidth: 200,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => (
        <Typography color="primary" variant="body2">
          {row.name} {row.surnames}
        </Typography>
      ),
    },
    {
      field: "whoInvest",
      headerName: t("funds.companyName"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {row.whoInvest === `${row.name} ${row.surnames}`
              ? "-"
              : row.whoInvest}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: t("funds.amount"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(params.row.amount)}
          </Typography>
        );
      },
    },
    {
      field: "percentagePaid",
      headerName: t("funds.percentagePaid"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {params.row.percentagePaid}%
          </Typography>
        );
      },
    },
    {
      field: "amountPaid",
      headerName: t("funds.amountPaid"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const amount = params.row.amount;
        const percentage = params.row.percentagePaid;
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(amount * (percentage / 100))}
          </Typography>
        );
      },
    },
    {
      field: "toBePaid",
      headerName: t("funds.toBePaid"),
      minWidth: 160,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const amount = params.row.amount;
        const percentage = params.row.percentagePaid;
        const amountPaid = amount * (percentage / 100);
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(amount - amountPaid)}
          </Typography>
        );
      },
    },
    {
      field: "investmentDate",
      headerName: t("funds.registrationDate"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {toSpanishDate(params.row.investmentDate)}
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 130,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
};

export const columnsDistributionFund = (
  t,
  onDeleteClick,
  onEditClick,
  onDivestmentClick
) => {
  return [
    {
      field: "startup",
      headerName: t("opportunities.startup"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "roundNumber",
      headerName: t("opportunities.roundNumber"),
      minWidth: 160,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "amount",
      headerName: t("opportunities.amountInvested"),
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(params.row.amount)}
          </Typography>
        );
      },
    },
    {
      field: "participationValuation",
      headerName: t("positions.participationValuation"),
      minWidth: 160,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => {
        const resp = params.row.participationValuation;
        return isNaN(resp) || resp === null || resp === "Infinity"
          ? "-"
          : numberFormat(resp);
      },
    },
    {
      field: "shares",
      headerName: t("positions.shares"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => {
        const resp = (
          params.row.amount / params.row.participationValuation
        ).toFixed(2);
        return isNaN(resp) || resp === null || resp === "Infinity"
          ? "-"
          : numberFormat(resp).slice(0, -1);
      },
    },
    {
      field: "newAmount",
      headerName: t("positions.newAmount"),
      minWidth: 140,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const resp =
          row.investmentType === "Ampliación Capital"
            ? numberFormat(row?.lastValoration)
            : "NaN";
        return resp === "NaN" ? "-" : resp;
      },
    },
    {
      field: "capitalGain",
      headerName: t("positions.capitalGain"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: ({ row }) => {
        const sharesAmount = row.amount / row.participationValuation;
        const newCapital = sharesAmount * row.lastValoration;
        const resp =
          row.investmentType === "Ampliación Capital"
            ? (newCapital - row.amount).toFixed(2)
            : "-";
        return isNaN(resp) || resp === Infinity || resp === null
          ? "-"
          : numberFormat(resp);
      },
    },
    {
      field: "investmentType",
      headerName: t("opportunities.investmentType"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {row?.investmentType === "Ampliación Capital"
              ? t("opportunities.investmentTypeCapitalIncrease")
              : t("opportunities.investmentTypeEquityLoan")}
          </Typography>
        );
      },
    },
    {
      field: "urlVideo",
      headerName: t("opportunities.urlVideo"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.urlVideo} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "url",
      headerName: t("opportunities.url"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.url} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 130,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton
              color="secondary"
              onClick={() => onDivestmentClick(params)}
            >
              <AttachMoneyIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
};

export const columnsViewDetail = (t, investment, totalAmount) => {
  return [
    {
      field: "startup",
      headerName: t("opportunities.startup"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "roundNumber",
      headerName: t("opportunities.roundNumber"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "amount",
      headerName: t("funds.cost"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const myPercentage = (investment.amount * 100) / totalAmount;
        return (
          <Typography color="primary" variant="body2">
            {numberFormat((row.amount * (myPercentage / 100)).toFixed(2))}
          </Typography>
        );
      },
    },
    // {
    //     field: 'amountPaid',
    //     headerName: t('funds.amountPaid'),
    //     minWidth: 130,
    //     flex: 1,
    //     align: 'center',
    //     headerAlign: 'center',
    //     renderCell: ({ row }) => {
    //         const myPercentage = (investment.amount * 100) / totalAmount
    //         const myAmount = row.amount * (myPercentage / 100)
    //         return (<Typography color='primary' variant='body2'>{numberFormat((myAmount * (investment.percentagePaid/100)).toFixed(2))}</Typography>
    //         )
    //     }
    // },
    {
      field: "fairValue",
      headerName: t("funds.fairValue"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const shares = row.amount / row.participationValuation;
        const myPercentage = (investment.amount * 100) / totalAmount;
        const myShares = shares * (myPercentage / 100);
        const fairValue = myShares * row.lastValoration;
        return (
          <Typography color="primary" variant="body2">
            {row.investmentType === "Préstamo Convertible"
              ? "-"
              : numberFormat(fairValue.toFixed(2))}{" "}
          </Typography>
        );
      },
    },
  ];
};
